export default __webpack_public_path__ + "static/media/bg_09.69045a8c.png";